import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const login = createAsyncThunk(
  "auth/login",
  async (_, { rejectWithValue }) => {
    try {
      // Static login - no API call, just return the static token
      const staticTokenData = {
        access_token: "1|x6o3jANSVe5eUc7sPGyoSlwmGHnDoyv029AeeH1U6278c9a5",
        token_type: "Bearer"
      };
      
      console.log("Static login successful with token:", staticTokenData.access_token);
      
      return staticTokenData;
    } catch (error) {
      const message = error?.response?.data || { message: error.message };
      return rejectWithValue(message);
    }
  }
);

// Get token from localStorage if available
const getStoredToken = () => {
  try {
    const storedToken = localStorage.getItem('access_token');
    const storedTokenType = localStorage.getItem('token_type');
    return {
      access_token: storedToken,
      token_type: storedTokenType || 'Bearer'
    };
  } catch (error) {
    return { access_token: null, token_type: null };
  }
};

const storedAuth = getStoredToken();

const initialState = {
  access_token: storedAuth.access_token,
  token_type: storedAuth.token_type,
  status: "idle",
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout(state) {
      state.access_token = null;
      state.token_type = null;
      state.status = "idle";
      state.error = null;
      // Clear from localStorage
      localStorage.removeItem('access_token');
      localStorage.removeItem('token_type');
    },
    setToken(state, action) {
      state.access_token = action.payload.access_token;
      state.token_type = action.payload.token_type || 'Bearer';
      // Save to localStorage
      localStorage.setItem('access_token', action.payload.access_token);
      localStorage.setItem('token_type', state.token_type);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.access_token = action.payload.access_token;
        state.token_type = action.payload.token_type;
        // Save to localStorage
        localStorage.setItem('access_token', state.access_token);
        localStorage.setItem('token_type', state.token_type);
      })
      .addCase(login.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || action.error?.message || "Login failed";
      });
  },
});

// Utility function to set token manually
export const setTokenManually = (token, tokenType = 'Bearer') => {
  return setToken({ access_token: token, token_type: tokenType });
};

export const { logout, setToken } = authSlice.actions;
export default authSlice.reducer;


